export enum AudienceEnum {
    MemberDescription = 'Member',
    Member = 1,
    CaregiverDescription = 'Caregiver',
    Caregiver = 2,
    FamilyMemberDescription = 'Family Member',
    FamilyMember = 3,
}
